export enum enShippingType {
  FREE = '1',
  FIXED = '2'
}